module.exports = __webpack_public_path__ + "media/check.c5daa1e6.svg";